export default "__VITE_ASSET__b0386b67__"